<template>
  <div class="dg-page">
    <div class="bg-[#fff] p-[20] mb-[16] shadow" v-if="$slots.leftBtns && timeTypeOptions[0].length">
      <div class="flex items-center" v-if="timeTypeOptions[0].length">
        <el-time-type ref="timeType" @change="handleTime" v-model="timeType" :data="timeTypeOptions" placeholder="选择时间">
        </el-time-type>
        <p v-if="formattedTime && formattedTime === 'customize'" class="pl-[8]">
          <el-date-picker size="small" range-separator="至" type="datetimerange" start-placeholder="开始日期"
            end-placeholder="结束日期" v-model="daterange"> </el-date-picker>
        </p>
        <span class="pl-[16] t-[12] t-[#000000]" v-else>{{ formattedTime }}</span>
      </div>
    </div>
    <div class="bg-[#fff] p-[20]">
      <div class="pb-[10]" v-if="tips.msg">
        <transition name="el-zoom-in-top">
          <el-alert @close="
            () => {
              tips.msg = '';
            }
          " :title="tips.msg" :type="tips.type" show-icon>
          </el-alert>
        </transition>
      </div>
      <div class="search-box" v-if="showSearch">
        <div class="left-area">
          <slot v-if="$slots.leftBtns" name="leftBtns"></slot>
          <div v-else>
            <div class="flex items-center" v-if="timeTypeOptions[0].length">
              <el-time-type ref="timeType" @change="handleTime" v-model="timeType" :data="timeTypeOptions"
                placeholder="选择时间"> </el-time-type>
              <p v-if="formattedTime && formattedTime === 'customize'" class="pl-[8]">
                <el-date-picker size="small" range-separator="至" type="datetimerange" start-placeholder="开始日期"
                  end-placeholder="结束日期" v-model="daterange"> </el-date-picker>
              </p>
              <span class="pl-[16] t-[12] t-[#000000]" v-else>{{ formattedTime }}</span>
            </div>
          </div>
        </div>
        <div class="right-area" v-if="showSearchRightArea">
          <dg-search-input ref="searchInputRef" v-if="showSearchInput" :searchGroups="searchGroups"
            @handleSingleSearch="handleSingleSearch" @handleMultipleSearch="handleMultipleSearch"></dg-search-input>
          <div v-if="showfiltersBtns" class="right-action-btns">
            <el-tooltip class="item" effect="dark" content="重置" placement="top">
              <el-button icon="el-icon-refresh" size="small" plain class="icon-btns" @click="handleResetSearch"
                :loading="loadingSearch" v-show="showLoading"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="自定义列表" placement="top">
              <el-button icon="el-icon-setting" size="small" plain class="icon-btns" @click="handleSetting"
                v-show="showSetting"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导出" placement="top">
              <el-button v-show="showExport" icon="el-icon-upload2" size="small" plain class="icon-btns"
                @click="handleExport"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导入" placement="top">
              <el-button v-show="showImport" icon="el-icon-download" size="small" plain class="icon-btns"
                @click="handleImport"></el-button>
            </el-tooltip>
            <slot name="rightActionBtns"></slot>
          </div>
        </div>
      </div>
      <!-- 搜索条件回显 -->
      <div v-if="searchTags.length" class="search-bar">
        <el-search-bar :total="pagination.total" :searchTags="searchTags" @handleClose="handleCloseTag"
          @handleClear="handleResetSearch"></el-search-bar>
      </div>
      <!-- 此次后台改变  tableLoading：默认设置false -->

      <!-- <keep-alive :include="['dg-table', 'dg-search-table']"> -->
      <dg-table :columns="filterColumns()" :api="api" :showSelection="showSelection" :showIndex="showIndex"
        :tableData="tableData" :showPagination="showPagination" :pagination="pagination"
        @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange" @handleSortChange="handleSortChange"
        @handleSearchStatus="handleSearchStatus" :row-class-name="rowClassName">
        <template v-for="item in slots" v-slot:[item]="scope">
          <slot :name="item" v-bind="scope"></slot>
        </template>
      </dg-table>
      <!-- <el-search-table :key="Math.random()" :columns="filterColumns()" :showSelection="showSelection"
          :showIndex="showIndex" :tableData="tableData" :showPagination="showPagination" :pagination="pagination"
          @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange" @handleSortChange="handleSortChange" :tableLoading="false"
          :row-class-name="rowClassName">
          <template v-for="item in slots" v-slot:[item]="scope">
            <slot :name="item" v-bind="scope"></slot>
          </template>
          <template v-for="(item, index) in customHeader" #[item.header]>
            <div class="flex items-center">
              <DgSearchHeader :label="item.label" :checkBoxList="item.statusAll" keys="key"
                @checked="(obj) => handleSearchStatus(obj, item, index)" :defaultCheckBoxList="item.checkStatus"
                :isMultiple="item.isMultiple"></DgSearchHeader>
            </div>
          </template>
        </el-search-table> -->
      <!-- </keep-alive> -->
    </div>
    <!-- 设置弹窗 -->
    <el-dialog custom-class="setting-dialog" :show-close="false" :visible.sync="dialogVisible" width="700px">
      <template slot="title">
        <div class="dialog-title">
          <div class="title">自定义列表</div>
          <i class="el-icon-circle-close dialog-close-icon" @click="dialogVisible = false"></i>
        </div>
      </template>
      <div class="dialog-content">
        <div class="checked-box">选中：{{ checkList.length }}/{{ checkboxs.length }}。清除缓存或更换浏览器，自定义列表失效。</div>
        <el-checkbox-group class="checkbox-group" v-model="checkList">
          <div class="checkbox-item" v-for="(item, index) in checkboxs" :key="index">
            <el-checkbox :label="item.prop" :disabled="item.disabled">{{ item.label }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false" plain>取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitSetting">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { formatDate } from "@/assets/js/utils";
import DgSearchInput from "./dg-search-input.vue";
import DgTable from "./dg-table.vue";
function formatDate_(start, end) {
  return [formatDate(start).slice(0, 11) + "00:00:00", formatDate(end).slice(0, 11) + "23:59:59"].toString();
}
export default {
  mixins: [mixin],
  name: "DgPage",
  props: {
    api: Object,
    columns: Array,
    formData: {
      type: Object,
      default: () => { },
    },
    formItems: Array,
    defaultFormData: Array,
    // 是否显示整个筛选区域
    showSearch: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧筛选区域
    showSearchRightArea: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧筛选输入框
    showSearchInput: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧操作按钮图标
    showfiltersBtns: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧重置按钮图标
    showLoading: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧自定义列表设置按钮图标
    showSetting: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧导出按钮图标
    showExport: {
      type: Boolean,
      default: false,
    },
    // 是否显示右侧导入按钮图标
    showImport: {
      type: Boolean,
      default: false,
    },
    // 是否显示列表复选框
    showSelection: {
      type: Boolean,
      default: false,
    },
    // 是否显示列表序号
    showIndex: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    rowClassName: {
      type: Function,
      default: null
    },
    extraTimeOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tips: {
        msg: "",
        type: "error",
      },
      loadingSearch: false,
      daterange: [],
      tableData: [],
      searchTags: [],
      timeType: [],
      pagination: {
        pageNo: 1, // 页数
        pageSize: 10, // 条数
        total: 0,
      },
      // 默认时间范围选项（不含extraTimeOptions）
      defaultTimeRangeOptions: [
        {
          value: (() => {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime());
            return formatDate_(start, end);
          })(),
          label: "今天",
        },
        {
          value: (() => {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            return formatDate_(start, end);
          })(),
          label: "昨天",
        },
        {
          value: (() => {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            return formatDate_(start, end);
          })(),
          label: "最近一周",
        },
        {
          value: (() => {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            return formatDate_(start, end);
          })(),
          label: "最近一个月",
        },
      ],
      timeTypeOptions: [
        [],
        [], // 将在extractionTime中动态填充
      ],
      dialogVisible: false,
      checkList: [], //自定义列表
      checkboxs: [], //自定义列表复选框
      currentForm: {},
      searchGroups: [],
      customHeader: [],
      statusCheckoutVals: [],
      statusCheckoutItem: {},
      searchStatus: "",
      searchStatusVals: [],
      searchStatusIndex: -1,
      sorts: [], // 排序字段
    };
  },

  components: {
    DgSearchInput,
    DgTable,
  },

  computed: {
    formattedTime() {
      if (this.timeType[1]) {
        return this.timeType[1].split(",").join(" - ");
      }
      return "";
    },
    // 自定义列表行列内容
    slots() {
      let arr = [];
      this.columns.forEach((item) => {
        if (item.slotProp) {
          arr.push(item.slotProp);
        }
      });
      return arr;
    },
    localStorageKey() {
      const PAGE_KEY = window.location.hash ? window.location.hash : window.location.host;
      return `${PAGE_KEY}-${this.api.list.url}`;
    },
  },
  watch: {
    daterange(val) {
      this.resetTimeType();
      if (!this.timeType[0]) {
        this.timeType[0] = this.timeTypeOptions[0];
      }
      let [key1, key2] = this.timeType[0].split(",");
      if (val) {
        this.currentForm[key1] = formatDate(val[0]) ? formatDate(val[0]) : "";
        this.currentForm[key2] = formatDate(val[1]) ? formatDate(val[1]) : "";
      } else {
        this.currentForm[key1] = "";
        this.currentForm[key2] = "";
      }
      this.getList();
    },
    formData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.currentForm = { ...newVal };
        }
      },
    },
  },
  filters: {
    time: (val) => {
      if (val) {
        return val.split(",").join(" - ");
      }
      return "";
    },
  },

  methods: {
    // 获取搜索框组合
    getSearchGroups() {
      if (!this.showSearchInput || !this.showSearch || !this.formItems || !this.formItems.length) return;
      let searchGroups = [];
      for (let i = 0; i < this.formItems.length; i++) {
        const item = this.formItems[i];
        const statusItem = this.api.status && this.api.status.find((cur) => cur.key == item.key);
        if (statusItem?.url && statusItem?.url != "/customer/status") {
          searchGroups.push({
            url: statusItem?.url || '',
            key: item.key,
            label: item.label,
            params: statusItem?.params || {},
            type: item.type,
            options: statusItem?.options || [],
            isMultiple: item.isMultiple,
          })
        } else if (item.type != 'date') {
          searchGroups.push({
            key: item.key,
            label: item.label,
            type: item.type,
            options: statusItem?.options || [],
            isMultiple: item?.isMultiple,
          })
        }
      }
      this.searchGroups = searchGroups;
    },
    // 列表过滤行列
    filterColumns() {
      const _columns = JSON.parse(localStorage.getItem(this.localStorageKey) || "[]");
      if (_columns && _columns.length) {
        return this.columns.filter((item) => _columns.indexOf(item.prop) > -1 || item.prop == "action");
      } else {
        return this.columns;
      }
    },
    // 列表复选框事件
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 导出
    handleExport() {
      this.$emit("handleExport", { ...this.currentForm, ...this.pagination });
    },
    // 导入
    handleImport() {
      this.$emit("handleImport", { ...this.currentForm, ...this.pagination });
    },
    // 确认提交设置弹窗
    handleSubmitSetting() {
      this.dialogVisible = false;
      localStorage.setItem(this.localStorageKey, JSON.stringify(this.checkList));
      this.filterColumns();
    },
    // 删除单个搜索条件
    handleCloseTag(tag) {
      const index = this.api.status.findIndex((item) => item.key == tag.key);
      if (index > -1) {
        this.statusCheckoutVals = [];
        this.statusCheckoutItem = {};
        this.$bus.$emit(`handleClearHeaderCheckout${tag.key}`);
        this.currentForm[tag.key] = "";
        this.getList();
      }
      this.$refs.searchInputRef && this.$refs.searchInputRef.handleClearItem(tag.key);
    },
    // 清空搜索条件
    handleResetSearch() {
      if (!this.$refs.timeType && !this.$refs.searchInputRef) {
        this.searchTags = [];
        this.handleMultipleSearch(this.formData)
      }
      if (this.api && this.api.status && this.api.status.length) {
        this.$bus.$emit('handleClearHeaderCheckout');
      }
      this.timeType = [];
      this.$refs.timeType && this.$refs.timeType.reset();
      this.$refs.searchInputRef && this.$refs.searchInputRef.handleClear();
    },
    // 表头搜索事件
    handleSearchStatus(obj) {
      this.pagination.pageNo = 1;
      this.statusCheckoutVals = obj.isCheckIdList;
      this.statusCheckoutItem = { ...obj };
      if (this.statusCheckoutVals.length == 0) {
        return;
      }
      let searchs = { keyName: obj.label, key: this.statusCheckoutItem.currentKey, value: [] };
      this.statusCheckoutVals.forEach((item) => {
        const result = this.statusCheckoutItem.initList.find((curr) => {
          return curr.key.toString() == item;
        });
        searchs.value.push(result.value);
      });
      searchs.value = searchs.value.toString();
      const index = this.searchTags.findIndex((item) => item.key == searchs.key);
      if (index > -1) {
        this.$set(this.searchTags, index, searchs);
      } else {
        this.searchTags.push({ ...searchs });
      }
      const res = this.statusCheckoutVals.toString();
      this.$set(this.currentForm, this.statusCheckoutItem.currentKey, res);
      this.getList();
    },
    // 打开自定义列弹窗
    handleSetting() {
      this.handleInitCheckBox(this.columns);
      this.dialogVisible = true;
    },
    // 初始化自定义列表多选框
    handleInitCheckBox(columns) {
      this.checkboxs = columns.filter((item) => item.prop !== "action");
      const _columns = JSON.parse(localStorage.getItem(this.localStorageKey) || "[]");
      if (_columns && _columns.length) {
        const deffs = _columns.concat(this.checkboxs).filter((v, i, arr) => {
          return arr.indexOf(v) === arr.lastIndexOf(v);
        });
        if (deffs.length > 0 && this.checkboxs.every((item) => deffs.includes(item.prop) == -1)) {
          this.checkList = this.checkboxs.filter(item => !item.notSelect).map((item) => item.prop);
          localStorage.setItem(this.localStorageKey, JSON.stringify(this.checkList));
        } else {
          this.checkList = _columns;
        }
      } else {
        this.checkList = this.checkboxs.filter(item => !item.notSelect).map((item) => item.prop);
        localStorage.setItem(this.localStorageKey, JSON.stringify(this.checkList));
      }
    },
    /**
     * @author 伟健 / 张
     * @name 重置时间
     */
    resetTimeType() {
      let option = this.timeTypeOptions[0];
      if (option) {
        option.forEach((el) => {
          if (el.value) {
            let [key1, key2] = el.value.split(",");
            this.currentForm[key1] = "";
            this.currentForm[key2] = "";
          }
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 选择时间类型
     */
    handleTime(val) {
      this.resetTimeType();
      // 当选择日期字段时，动态更新时间范围选项
      if (val[0]) {
        const selectedField = this.timeTypeOptions[0].find(item => item.value === val[0]);
        if (selectedField) {
          // 根据所选字段是否有extraTime来设置时间范围选项
          this.setTimeRangeOptions(selectedField.extraTime === true);
        }
      }
      if (val[0] && val[1] && val[1] !== "customize") {
        let [key1, key2] = val[0].split(",");
        let [val1, val2] = val[1].split(",");
        this.currentForm[key1] = val1;
        this.currentForm[key2] = val2;
        this.getList();
      }
    },
    /**
     * @author 伟健 / 张
     * @name 单个搜索
     * @param
     * @return
     */
    handleSingleSearch(params) {
      this.hanldeSearch(params);
    },
    // 多维搜索
    handleMultipleSearch(params) {
      this.hanldeSearch(params);
    },
    // 条件搜索
    hanldeSearch(params) {
      this.searchTags = [];
      this.pagination.pageNo = 1;
      this.currentForm = { ...this.formData, ...this.currentForm };
      const hasOwnProperty = Object.prototype.hasOwnProperty;
      if (params.length) {
        params.forEach((item) => {
          let value = "";
          let tag = "";
          if (item.type == "select" && item.isMultiple) {
            tag = item.value ? item.value.map((curr) => curr.value).toString() : "";
            value = item.value ? item.value.map((curr) => curr.key).toString() : "";
          } else if (item.type == "select" && !item.isMultiple) {
            tag = item.value[0]["value"];
            value = item.value[0]["key"];
          } else {
            tag = item.value || "";
            value = item.value || "";
          }
          this.searchTags.push({ ...item, value: tag });
          if (hasOwnProperty.call(this.currentForm, item.key)) {
            this.currentForm[item.key] = value;
          }
        });
      } else {
        Object.keys(this.currentForm).forEach((key) => {
          // 过滤掉搜索时时间类型有数据的情况
          const findTimeOption = this.timeTypeOptions[0].find((item) => {
            return this.currentForm[item.value.split(",")[0]]
          })
          if (this.currentForm[findTimeOption?.value.split(",")[0]]) return
          if (this.defaultFormData && this.defaultFormData.includes(key)) return;
          this.currentForm[key] = "";
        });
      }
      this.getList();
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getList();
    },

    /**
     * @author 伟健 / 张
     * @name 列表
     */
    getList() {
      this.loadingSearch = true;
      if (!this.api.list) return;
      let data = { ...this.currentForm, ...this.pagination };
      // 此处为后台特别需要将改变的数据传递给父组件
      this.$emit("updateFormData", this.currentForm);
      let d = {
        url: this.api.list.url,
        self: this,
        data: {},
        success: (res) => {
          if (res) {
            try {
              if (this.api.list.after) {
                res = this.api.list.after(res);
              }
              this.tableData = res.result || [];
              if (this.tableData.length > 0) {
                // 此处为后台特别需要将数据传递给父组件,列表背景色
                this.$emit("updateTableData", this.tableData);
              }
              this.pagination.total = res.totalItems || 0;
              this.loadingSearch = false;
            } catch (e) {
              console.log(e);
            }
          }
        },
        fail: () => {
          this.loadingSearch = false;
        },
      };
      d.data = data;
      // if (this.api.list.method == 'post') {
      //   d.data = data
      // }
      // if (this.api.list.method == 'get') {
      //   d.data = data
      // }
      ajax[this.api.list.method || "post"](d);
    },
    /**
     * @author 伟健 / 张
     * @name 提取时间/
     */
    extractionTime() {
      if (this.formItems) {
        this.formItems.forEach((el) => {
          if (el.type == "date") {
            this.timeTypeOptions[0].push({
              value: el.key,
              label: el.label,
              extraTime: el.extraTime,
            });
          }
          if (el.slotProp) {
            this.slots.push(el.slotProp);
          }
        });
      }
      // 初始时使用默认时间范围选项
      this.setTimeRangeOptions(false);
    },
    // 根据是否包含extraTime来设置时间范围选项
    setTimeRangeOptions(hasExtraTime) {
      // 清空现有选项
      this.timeTypeOptions[1] = [];
      // 添加默认时间范围选项
      this.defaultTimeRangeOptions.forEach((el) => {
        this.timeTypeOptions[1].push(el);
      });
      // 如果需要extraTime，则添加extraTimeOptions
      if (hasExtraTime && this.extraTimeOptions.length) {
        this.extraTimeOptions.forEach((el) => {
          this.timeTypeOptions[1].push(el);
        });
      }
      // 添加自定义选项
      this.timeTypeOptions[1].push({
        value: "customize",
        label: "自定义",
      });
    },
    camelToUnderscore(str) {
      // 匹配所有大写字母，并在其前插入下划线，然后整体转为小写
      return str.replace(/([A-Z])/g, "_$1").toLowerCase();
    },

    // 列表自定义排序
    handleSortChange(val) {
      let sortForm = {
        sortField: val.prop,
        sortDirection: val.order ? val.order.indexOf("asc") > -1 ? "ASC" : "DESC" : '',
      }
      const findSortIndex = this.sorts.findIndex((item) => item.sortField == sortForm.sortField);
      if (findSortIndex > -1) {
        this.sorts.splice(findSortIndex, 1);
      }
      if (sortForm.sortDirection) {
        this.sorts.unshift(sortForm);
      }
      this.currentForm.sortField = this.sorts.map((item) => item.sortField).toString();
      this.currentForm.sortDirection = this.sorts.map((item) => item.sortDirection).toString();
      this.$bus.$emit('handleSortHeaderNum', this.sorts);
      this.getList();
    },
  },
  mounted() {
    let time = null;
    Mirror.watch(["table_success_tips_open", "table_success_tips", "table_tips", "table_tips_open"], (key, tips) => {
      if (tips && tips.msg) {
        this.tips.msg = tips.msg;
        this.tips.type = tips.type;
        clearInterval(time);
        setTimeout(() => {
          this.tips.msg = "";
        }, 3000);
      } else {
        this.tips.msg = "操作失败";
        this.tips.type = "error";
      }
    });
    Mirror.watch(["loading_el_alert_box_open"], () => {
      this.loadingSearch = true
    });
    Mirror.watch(["loading_el_alert_box_close"], () => {
      this.loadingSearch = false
    });
  },
  created() {
    this.extractionTime();
    this.getList();
    this.getSearchGroups();
  },
};
</script>

<style lang="less" scoped>
.dg-page {
  .search-box {
    display: flex;
    justify-content: space-between;

    .left-area {
      display: flex;
      align-items: center;
    }

    .right-area {
      display: flex;
      align-items: center;

      .right-action-btns {
        margin-left: 8px;

        .icon-btns {
          font-size: 16px !important;
          padding: 7px !important;

          &:hover,
          &:focus,
          &:active {
            border-color: #c3cad9 !important;
          }
        }

        button+button {
          margin-left: 4px !important;
        }
      }
    }
  }

  .dialog-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      color: #303133;
      line-height: 20px;
    }

    .dialog-close-icon {
      font-size: 18px;
      cursor: pointer;
    }
  }

  .dialog-content {
    .checked-box {
      width: 100%;
      background: #fafafc;
      height: 38px;
      line-height: 38px;
      box-sizing: border-box;
      padding-left: 16px;
      font-size: 12px;
      color: #000000;
      border-bottom: 1px solid #d2d6ea;
    }

    .checkbox-group {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 19px 20px;

      .checkbox-item {
        flex-basis: 165px;
        height: 56px;
        display: flex;
        box-sizing: border-box;
        padding: 0 8px;
        justify-content: flex-start;
        align-items: center;

        .el-checkbox__label {
          font-size: 12px;
          color: #000000;
        }

        .el-checkbox__input.is-checked+.el-checkbox__label {
          color: var(--primary-color) !important;
        }
      }
    }
  }

  .dialog-footer {
    .el-button--small {
      padding: 9px 10px;
    }
  }
}

/deep/ .el-dialog {
  border-radius: 6px;
}

// 列表行列展示弹窗开始
/deep/ .el-dialog__header {
  padding: 16px !important;
  border-bottom: 1px solid #c3cad9;
}

/deep/ .el-dialog__body {
  padding: 0;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #c3cad9;
  padding: 15px 16px;
}

.checkbox-pop {
  box-sizing: border-box;
  padding: 8px 16px;

  .checkbox-item {
    box-sizing: border-box;
    padding: 8px 0;
  }

  ::v-deep .el-checkbox__label {
    padding-left: 8px;
    display: inline-block;
    vertical-align: text-top;
    max-width: 190px;
    white-space: normal;
  }
}

.status-icon-hover {
  &:hover {
    color: var(--primary-color);
  }
}

.shadow {
  border-radius: 4px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px -4px rgba(0, 0, 0, 0.12), 0px 4px 4px -2px rgba(0, 0, 0, 0.05), inset 0px -2px 0px 0px rgba(0, 0, 0, 0.08);
}

.table-header-dropdown[x-placement^="bottom"] {
  max-height: 300px;
  overflow-y: auto;
}

/deep/ .el-table .row-bg-0 {
  position: relative;
  background: #F9FBFF;
}

/deep/ .el-table tr.row-bg-0::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background-color: #79A3F8;
  z-index: 1;
}

/deep/ .el-table tr.row-bg-1 {
  position: relative;
  background: #F4FAFA;
}

/deep/ .el-table tr.row-bg-1::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background-color: #85DFD2;
  z-index: 1;
}
</style>
